module.exports = __webpack_public_path__ + "img/1475285211.27a808d4.jpg";